// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"25e1df6a","228":"92232b52","433":"ce4d48fb","606":"4d6c5b9e","723":"c88e1b8e","830":"2d53c71f"}[chunkId] + ".chunk.js";
};